<div class="sidebar-title">
    <h2 [ngStyle]="{'font-size':isCollapsed?'16px':'24px'}">
        <div>
            <img src="../../../assets/image/Logo3.png"
                style="width: 100%;height: 100%;margin-top: -12px;cursor: pointer;" (click)="GoPage()" alt="">
        </div>
    </h2>
</div>
<div [ngClass]="{'scroll-menu': !isSmallScreen}">
    <ul nz-menu nzMode="inline" nzTheme="dark" [nzInlineCollapsed]="isCollapsed">
        <ng-container *ngFor="let menu of menus">
            <li nz-submenu nzTitle="{{ menu.programName | translate}}" [nzOpen]="menu.isOpen"
                (nzOpenChange)="OpenChange(menu.menuId, $event)" nzMatchRouter [nzIcon]="menu.icon">
                <ul *ngIf="menu.childMenus">
                    <ng-container *ngFor="let child of menu.childMenus">
                        <li *ngIf="!child.childMenus" nz-menu-item nzMatchRouter>
                            <a *ngIf="child.isExternalMenu==='N'" [routerLink]="[child.tCode]">{{ child.programName|
                                translate }}</a>

                            <a *ngIf="child.isExternalMenu==='Y'" href="{{mvmSiteNew}}{{child.tCode}}" target="_self">{{
                                child.programName| translate }}</a>
                        </li>
                        <li nz-submenu *ngIf="child.childMenus" nzTitle="{{ child.programName | translate  }}"
                            [nzOpen]="child.isOpen" [nzIcon]="child.icon"
                            (nzOpenChange)="OpenChange(child.menuId, $event)">
                            <ul *ngIf="child.childMenus">
                                <ng-container *ngFor="let subChild of child.childMenus">

                                    <li nz-menu-item nzMatchRouter *ngIf="!subChild.childMenus">
                                        <a *ngIf="subChild.isExternalMenu==='N'" [routerLink]="[subChild.tCode]">{{
                                            subChild.programName|
                                            translate }}</a>
                                        <a *ngIf="subChild.isExternalMenu==='Y'" href="{{mvmSiteNew}}{{subChild.tCode}}"
                                            target="_self">{{
                                            subChild.programName| translate }}</a>
                                    </li>
                                    <li nz-submenu *ngIf="subChild.childMenus"
                                        nzTitle="{{ subChild.programName | translate  }}" [nzOpen]="subChild.isOpen"
                                        [nzIcon]="subChild.icon" (nzOpenChange)="OpenChange(subChild.menuId, $event)">
                                        <ul *ngIf="subChild.childMenus">
                                            <ng-container *ngFor="let subSubChild of subChild.childMenus">
                                                <li nz-menu-item nzMatchRouter>
                                                    <a *ngIf="subSubChild.isExternalMenu==='N'"
                                                        [routerLink]="[subSubChild.tCode]">{{
                                                        subSubChild.programName| translate }}</a>
                                                    <a *ngIf="subSubChild.isExternalMenu==='Y'"
                                                        href="{{mvmSiteNew}}{{subSubChild.tCode}}" target="_self">{{
                                                        subSubChild.programName| translate }}</a>
                                                </li>
                                            </ng-container>
                                        </ul>
                                    </li>
                                </ng-container>
                            </ul>
                        </li>
                    </ng-container>
                </ul>
            </li>
        </ng-container>
    </ul>

    <div class="version-wrapper" *ngIf="!isCollapsed">
        <label>Site Version: 1377207<span *ngIf="currentEnvironment === 'qas'"
                style="color: red;">QAS</span></label>
    </div>
</div>